import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import _ from 'lodash';
import {useStylesECDS} from './ecdsStyle';
import InformationBox from '../../../../components/other/informationBox';
import {AgyleTable, createAgyleTableColumn} from '../../../../components/table/AgyleTable';

const COLUMNS = [
    createAgyleTableColumn('no', 'No.', 1, null, 'count', 'notSort', 'medium', 'center', true, false, null, null, null),
    createAgyleTableColumn('diag', 'Diagnosis', 2, 'EmergencyCareDiagnosis_SnomedCt', 'dict', '', 'medium', 'left', true, false, null, null, null),
    createAgyleTableColumn('diagQualifier', 'Diagnosis Qualifier', 3, 'EmergencyCareDiagnosisQualifier_SnomedCt', 'dict', '', 'medium', 'left', true, true, null, null, null),
    createAgyleTableColumn('sequenceNumber', 'Clinical Entry Sequence Number', 4, 'CodedClinicalEntrySequenceNumber', 'string', '', 'medium', 'left', true, false, null, null, null),
];

const Diagnosis = (props) => {
    const {t} = useTranslation();
    const classes = useStylesECDS();

    // Multi Entry list
    const [list, setList] = useState([]);

    const setDataDictionary = () => {
        let formattedList = _.cloneDeep(list);
        for (const element of formattedList) {
            element.EmergencyCareDiagnosis_SnomedCt = element.EmergencyCareDiagnosis_SnomedCt?.snomedCode || null;
            element.EmergencyCareDiagnosisQualifier_SnomedCt = element.EmergencyCareDiagnosisQualifier_SnomedCt?.snomedCode || null;
        }
        const data = {EmergencyCareDiagnoses_SnomedCt: formattedList};
        props.setData(data);
    };

    useEffect(() => {
        let data = [];
        if (props.patient?.diagnosis?.primary) {
            props.patient.diagnosis.primary.map((entry) => {
                if (entry.value) {
                    data.push({
                        EmergencyCareDiagnosis_SnomedCt: entry.value,
                        EmergencyCareDiagnosisQualifier_SnomedCt: entry.qualifier ? entry.qualifier : null,
                        CodedClinicalEntrySequenceNumber: entry.sequenceNumber,
                    });
                }
            });
        }
        setList([...data]);

    }, []);

    useEffect(() => {
        setDataDictionary();
    }, [list]);

    if (props.accordion !== 'Emergency Care Diagnosis' && props.accordion !== 'Urgent And Emergency Care Diagnosis') return null;

    return (
        <div className={classes.root}>
            {!_.isEmpty(list) &&
                <AgyleTable
                    columns={COLUMNS}
                    data={list}
                    disableFilter
                />
            }
            {_.isEmpty(list) &&
                <InformationBox type="info">
                    {t('No Diagnosis Set.')}
                </InformationBox>
            }
        </div>
    );
};

export default Diagnosis;
